module.exports = __webpack_public_path__ + "static/img/100062.f51ececa.png";